<template>
  <div>
    <h3>Grands utilisateurs</h3>
    <table class="table table-sm">
      <thead>
        <tr>
          <th>Usager</th>
          <th>Type</th>
          <th>RLISS</th>
          <th style="text-align: right;">Interactions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for='user in sortedData' :key='user.username'>
          <td v-text="user.username"></td>
          <td v-text="user.privilege"></td>
          <td v-text="user.rliss"></td>
          <td style="text-align: right;" v-text="user.count"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ListeUsagers',
  props: {
    usagers: Array
  },
  computed: {
    sortedData() {
      // var output = Object.entries(this.usagers).map(([key, value]) => ({key,value}));
      // return output.sort((a,b) => (a.count < b.count) ? 1 : -1)
      //   .slice(1,16)
      return this.usagers
                .slice()
                .sort((a,b) => (a.count < b.count) ? 1 : -1)
                .slice(0,15);
    }
  }
}
</script>
